export default "__VITE_ASSET__B7S187YI__"